import React, { useCallback, useContext, useMemo } from 'react';
import { useLoader } from '../../api/useLoader';
import {
  MuligePraksisstedDto,
  PraksisstedbrukerDto,
  RolleDto,
} from '../../api/generated/studiested-generated-api';
import { StudiestedApiContext } from '../../api/StudiestedApiContext';
import translations from '../rolleliste.i18n';
import { useFormatMessageFor } from '../../i18n/translation';
import Autocomplete from '../../components/input/autocomplete';
import { PraksisstedRollerDto } from '../../api/generated/praksissted-generated-api';

interface RollelistePraksisstedbrukerDropDownProps {
  id: string;
  praksissted: MuligePraksisstedDto;
  rollerData: RolleDto[] | undefined;
  onChange: (selectedItem?: PraksisstedbrukerDto) => void;
}

const RollelistePraksisstedbrukerDropDown = ({
  id,
  praksissted,
  rollerData,
  onChange,
}: RollelistePraksisstedbrukerDropDownProps) => {
  const labels = useFormatMessageFor(translations);
  const { praksisstedApi } = useContext(StudiestedApiContext);

  const { data: praksisstedbrukereData, loading: praksisstedbrukereLoading } =
    useLoader(
      () =>
        praksisstedApi.praksisstederPraksisstedIdBrukereGet({
          pathParams: { praksisstedId: praksissted.id },
        }),
      [praksissted],
    );

  const existsPraksisstedbrukerRolle = useCallback(
    (aId: string, roleType: PraksisstedRollerDto) => {
      return (rollerData ?? [])
        .filter((v: RolleDto) => v.type.praksisstedrolle === roleType)
        .map((v) => v.id)
        .includes(aId);
    },
    [rollerData],
  );

  const filtrertePraksisstedbrukere = useMemo(() => {
    return praksisstedbrukereData?.filter(
      (val) =>
        !existsPraksisstedbrukerRolle(val.id, PraksisstedRollerDto.Veileder),
    );
  }, [existsPraksisstedbrukerRolle, praksisstedbrukereData]);

  return (
    <>
      {filtrertePraksisstedbrukere &&
        filtrertePraksisstedbrukere.length > 0 && (
          <Autocomplete
            id={`rolle-ps-autocomplete-${id}`}
            loading={praksisstedbrukereLoading}
            label={labels.name}
            options={filtrertePraksisstedbrukere?.map(
              ({ fornavn, etternavn, ...psbruker }) => ({
                ...psbruker,
                navn: `${fornavn} ${etternavn}`,
              }),
            )}
            onChange={(event: object, value: PraksisstedbrukerDto) => {
              onChange(value);
            }}
          />
        )}
      {filtrertePraksisstedbrukere &&
        filtrertePraksisstedbrukere.length === 0 &&
        labels.nopracticeUserDownMsg}
    </>
  );
};

export default RollelistePraksisstedbrukerDropDown;
